import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

import { COLUMN_DIFF_HEIGHT, MIN_COLUMN_HEIGHT } from '../../molecules/PriceBar/PriceBar.styles';

export const useCustomStyles = makeStyles()((theme) => ({
	container: {
		position: 'relative',
	},
	pricebarSlider: {
		display: 'flex',
		flexDirection: 'column',

		[getFromBreakpoint('lg')]: {
			flexDirection: 'row',
			justifyContent: 'center',
		},
	},
	priceBarContainer: {
		padding: 0,
		justifyContent: 'space-between',
		display: 'flex',
		flexDirection: 'row',
		listStyle: 'none',
		height: `calc(${MIN_COLUMN_HEIGHT}px + ${COLUMN_DIFF_HEIGHT}px +  ${theme.spacing.small})`,
		alignItems: 'flex-end',

		[getFromBreakpoint('md')]: {
			padding: `0 ${theme.spacing.xlarge}`,
			justifyContent: 'center',
		},
	},
	noOffersLink: {
		color: 'inherit',
		fontWeight: theme.weight.bold,
		textDecoration: 'underline',
	},
	swiftDepartureDates: {
		position: 'relative',
		bottom: 0,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		width: '100%',
	},
	controlButton: {
		alignSelf: 'center',
	},
	hiddenButton: {
		visibility: 'hidden',
	},
}));
